import { Megaphone, Trophy, Heart, Sparkles, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { PenMark } from "./BrandLogo";

const CHARACTERS = [
  {
    testid: "character-card-lil-momma",
    name: "Lil Momma",
    role: "The Energetic Cheerleader & Pep Leader",
    superpower: "Boundless cheer, a giant heart, and body-positivity ambassadorship for kids everywhere.",
    quote: "Believe in yourself, no matter your size!",
    color: "#D92B38",
    Icon: Megaphone,
    StatIcon: Heart,
    stat: "Spirit 110%",
  },
  {
    testid: "character-card-man-man",
    name: "Man-Man",
    role: "Football Captain #76 & Health Champion",
    superpower: "Leadership on the field and the courage to take charge of his own health.",
    quote: "Bruh, I got this!",
    color: "#1B365D",
    Icon: Trophy,
    StatIcon: Sparkles,
    stat: "Captain #76",
  },
];

export default function Characters() {
  return (
    <section id="characters" data-testid="characters-section" className="halftone relative border-y-2 border-ink bg-banana/40 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="text-center">
          <span className="sticker -rotate-1 rounded-lg bg-white">Meet the cousins</span>
          <h2 className="mx-auto mt-5 max-w-2xl font-head text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
            Two cousins. <span className="text-crimson">Double the heart.</span>
          </h2>
        </Reveal>

        <div className="relative mt-12 grid grid-cols-1 gap-8 md:grid-cols-2">
          <div className="absolute left-1/2 top-1/2 z-10 hidden -translate-x-1/2 -translate-y-1/2 md:block">
            <div className="rounded-full border-2 border-ink bg-white p-3 shadow-pop">
              <PenMark className="h-10 w-10" />
            </div>
          </div>

          {CHARACTERS.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.15}>
              <article
                data-testid={c.testid}
                className="group relative h-full overflow-hidden rounded-2xl border-2 border-ink bg-white p-8 shadow-pop transition-all duration-300 hover:-translate-y-1.5 hover:shadow-pop-lg sm:p-10"
              >
                <div
                  className="absolute -right-10 -top-10 h-40 w-40 rounded-full opacity-15 transition-transform duration-500 group-hover:scale-125"
                  style={{ backgroundColor: c.color }}
                  aria-hidden="true"
                />
                <div className="flex items-start justify-between">
                  <div
                    className="flex h-16 w-16 items-center justify-center rounded-2xl border-2 border-ink shadow-pop-sm transition-transform duration-300 group-hover:-rotate-6"
                    style={{ backgroundColor: c.color }}
                  >
                    <c.Icon className="h-8 w-8 text-cream" />
                  </div>
                  <span className="flex items-center gap-1.5 font-mono text-xs font-bold uppercase tracking-widest text-ink/50">
                    <c.StatIcon className="h-3.5 w-3.5" /> {c.stat}
                  </span>
                </div>

                <h3 className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl" style={{ color: c.color }}>
                  {c.name}
                </h3>
                <p className="mt-1 font-head text-sm font-bold uppercase tracking-wide text-ink/60">{c.role}</p>
                <p className="mt-4 text-base leading-relaxed text-ink/75">{c.superpower}</p>

                <blockquote className="mt-6 flex items-start gap-3 rounded-xl border-2 border-dashed border-ink/30 bg-cream p-4">
                  <Quote className="mt-0.5 h-5 w-5 shrink-0" style={{ color: c.color }} />
                  <span className="font-display text-lg font-semibold italic">“{c.quote}”</span>
                </blockquote>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
